import React, {Component} from 'react';

import Button    from '../../../components/Button';
import { getServerURL } from "@fyresite/fetch"

class EnrollmentConfirmation extends Component {
    constructor(props, context){
        super(props, context)
        this.state = {
            numPages: null,
            pageNumber: 1,
            link: `${getServerURL()}/api/v1/eligibility/voucher/${props.match.params.id}`
        }
    }

    handleContinue(e) {
        this.props.history.push('/dashboard/search-member')
    }

    render(){
        return (
            <div className="enrollment-confirmation">
                <div className="enrollment-confirmation-inner">
                    <div className="heading">
                        <h3>Enrollment has been completed.</h3>
                        <h4>You can download the pdf below</h4>
                    </div>
                    <div className="buttons">
                        <a href={this.state.link} download>
                            <Button flat={false}> Download </Button>
                        </a>
                        <Button flat={false} onClick={this.handleContinue.bind(this)}> Continue </Button>
                    </div>
                    <div>
                        <iframe title="voucher-form" src={this.state.link} width="100%" height="600px" />
                    </div>
                </div>
            </div>
        );
    }
}

export default EnrollmentConfirmation



// WEBPACK FOOTER //
// ./src/pages/Dashboard/EnrollmentConfirmation/EnrollmentConfirmation.js